export default function TableCell(theme) {
	return {
		MuiTableCell: {
			styleOverrides: {
				root: {},
				sizeSmall: {},
				head: {},
				footer: {}
			}
		}
	};
}
